var map = {
	"./logo.svg": "./src/remixIcon/svg/logo.svg",
	"./qq-fill.svg": "./src/remixIcon/svg/qq-fill.svg",
	"./vuejs-fill.svg": "./src/remixIcon/svg/vuejs-fill.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/remixIcon/svg sync \\.svg$";